import type { Dayjs } from 'dayjs';

export type ActivityDatePreferenceType = 'completionWindow' | 'preferred' | 'excluded';

export interface ActivityDatePreference {
  id: string | number;
  type: ActivityDatePreferenceType;
  start: Dayjs;
  end: Dayjs;
  /** System-managed rows (e.g. completion window) cannot be removed from the table. */
  isSystem?: boolean;
}

export function isPersistedActivityDatePreference(
  preference: ActivityDatePreference
): preference is ActivityDatePreference & { id: number } {
  return typeof preference.id === 'number' && !preference.isSystem;
}
